<div class="payment-account-selector" [formGroup]="form">
  <div
    id="no-saved-payment-accounts"
    *ngIf="!hasPaymentAccounts; else paymentAccountsList"
  >
    {{ 'ARC_PAYMENT_NO_SAVED_PAYMENT_METHODS' | translate }}
  </div>
  <ng-template #paymentAccountsList>
    <aur-field-wrapper [control]="control">
      <div class="payment-account-list">
        <div
          *ngFor="let account of paymentAccounts"
          [class]="'payment-account-option isDisabled-' + account.isDisabled"
        >
          <div class="payment-account">
            <p-radioButton
              [formControlName]="controlName"
              [inputId]="account.paymentAccountIdentifierBurn"
              [value]="account"
              [disabled]="account.isDisabled"
            ></p-radioButton>
            <label
              [for]="account.paymentAccountIdentifierBurn"
              class="payment-account-label"
            >
              <span class="payment-method-display-name">
                {{ account.displayName }}
              </span>

              <span
                *ngIf="account.showBadge"
                id="payment-account-status-badge"
                [class]="{
                  'aur-badge': true,
                  pending:
                    account.accountStatus == paymentAccountStatus.Pending,
                  suspended:
                    account.accountStatus == paymentAccountStatus.Suspended,
                  cancelled:
                    account.accountStatus == paymentAccountStatus.Cancelled
                }"
              >
                {{
                  paymentAccountStatusTranslations[
                    paymentAccountStatus[account.accountStatus]
                  ]
                    | translate
                    | titlecase
                }}
              </span>

              <span
                *ngIf="
                  showPadVerifiedBadges &&
                  account.paymentMethod == accountPaymentMethod.Ach
                "
                id="pad-verified-badge"
                [class]="{
                  'aur-badge': true,
                  padVerified: isPadVerified(account),
                  padNotVerified: !isPadVerified(account)
                }"
              >
                {{
                  account.padVerifiedStatus?.padVerified
                    ? account.padVerifiedStatus?.padSignedSeparately
                      ? ('ARC_PAYMENT_PAD_SIGNED_SEPARATELY_BADGE' | translate)
                      : ('ARC_PAYMENT_PAD_SIGNED_BADGE' | translate)
                    : ('ARC_PAYMENT_PAD_NOT_SIGNED_BADGE' | translate)
                }}
              </span>

              <div class="payment-method-details">
                {{ getAccountSubText(account) }}
              </div>

              <div class="card-related-inputs-container">
                <aur-input
                  *ngIf="
                    showUpdateExpirationDateInput && control.value == account
                  "
                  id="card-expiration-input"
                  inlineLabel="true"
                  label="{{
                    'ARC_PAYMENT_METHOD_CC_EXPIRATION_DATE_LABEL' | translate
                  }}"
                  [aurMask]="'M0/0000'"
                  formControlName="creditCardExpirationDate"
                  placeholder="MM/YYYY"
                  [errorMessages]="{
                    required:
                      'ARC_PAYMENT_METHOD_CC_EXPIRATION_DATE_REQUIRED_ERROR',
                    futureDate: futureExpirationDateErrorMessage,
                    expiredDate:
                      'ARC_PAYMENT_METHOD_CC_EXPIRATION_DATE_PAST_DATE_ERROR',
                    invalidFormat: 'ARC_PAYMENT_DATE_FORMAT_ERROR'
                  }"
                >
                </aur-input>
                <aur-input
                  *ngIf="account.shouldRequestCvv && control.value == account"
                  importance="tertiary"
                  id="card-cvv-input"
                  inlineLabel="true"
                  label="CVV"
                  type="text"
                  formControlName="creditCardCVV"
                  placeholder="***"
                  [errorMessages]="{
                    cvv: ('ARC_PAYMENT_CARD_CVV_INVALID' | translate)
                  }"
                >
                </aur-input>
              </div>
            </label>
            <button
              *ngIf="allowPaymentAccountsDeletion"
              aur-button
              [id]="
                'delete-payment-account-button-' +
                account.paymentAccountIdentifierBurn
              "
              type="button"
              importance="secondary"
              class="delete-payment-account-button"
              icon="delete"
              iconStyle="outline"
              (click)="onDeletePaymentAccountClicked(account)"
            ></button>
          </div>
        </div>
      </div>
      <aur-validation-error [control]="control"></aur-validation-error>
    </aur-field-wrapper>
  </ng-template>

  <aur-notice
    *ngIf="showSomeDocumentsNotPayableWarning"
    id="someDocumentsNotPayableWarning"
    severity="warning"
  >
    <span [innerText]="someDocumentsNotPayableWarningText"></span>
  </aur-notice>

  <payment-auth-verbiage
    id="surchargeAuthVerbiageText"
    *ngIf="showSurchargeVerbiage"
    [authVerbiageText]="surchargeAuthVerbiageText"
  />

  <aur-notice
    *ngIf="showPaymentMethodNotDiscountableWarning"
    id="paymentMethodNotDiscountableWarning"
    severity="information"
    >{{ 'ARC_PAYMENT_PAYMENT_METHOD_NOT_DISCOUNTABLE_WARNING' | translate }}
  </aur-notice>

  <aur-notice
    *ngIf="showDiscountLostPayableAmountUpdatedWarning"
    id="discountLostPayableAmountUpdatedWarning"
    severity="information"
    >{{
      'ARC_PAYMENT_DISCOUNT_LOST_PAYABLE_AMOUNT_UPDATED_WARNING' | translate
    }}
  </aur-notice>

  <aur-notice
    *ngIf="showDiscountsExpiredForNewDateWarning"
    id="discountsExpiredForNewDateVerbiage"
    severity="information"
    >{{ 'ARC_PAYMENT_DISCOUNTS_EXPIRED_FOR_NEW_DATE' | translate }}
  </aur-notice>

  <aur-notice
    *ngIf="showAchPaymentDateWarning"
    id="achPaymentDateWarningVerbiage"
    severity="information"
  >
    <span [innerText]="achPaymentDateWarningVerbiage"></span>
  </aur-notice>
  <aur-confirmation
    #deletePaymentAccountConfirmation
    id="delete-payment-method-popup"
    header="{{ 'ARC_PAYMENT_HEADER_DELETE_PAYMENT_METHOD' | translate }}"
    message="{{ 'ARC_PAYMENT_DELETE_PAYMENT_METHOD' | translate }}"
    acceptLabel="{{
      'ARC_PAYMENT_DELETE_PAYMENT_METHOD_DELETE_BUTTON' | translate
    }}"
    rejectLabel=" {{
      'ARC_PAYMENT_DELETE_PAYMENT_METHOD_CANCEL_BUTTON' | translate
    }}"
    (accept)="confirmPaymentAccountDeletion()"
  ></aur-confirmation>
</div>
